"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateCallbacks = void 0;
const exceptions_1 = require("./exceptions");
const okta_1 = require("./okta");
const signIn = (callback) => ({ user, account, profile, email, credentials, }) => __awaiter(void 0, void 0, void 0, function* () { return callback(user, account, profile, email, credentials); });
const redirect = (callback) => ({ url, baseUrl }) => callback(url, baseUrl);
const session = (callback) => ({ user, session: oktaSession, token: oktaToken, }) => __awaiter(void 0, void 0, void 0, function* () {
    const session = Object.assign({}, oktaSession);
    const token = Object.assign({}, oktaToken);
    session.accessToken = token.accessToken;
    session.error = token.error;
    return yield callback(session, oktaSession, user, token);
});
const jwt = (callback, okta) => ({ token, account }) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c;
    let jwt = Object.assign({}, token);
    if (account) {
        jwt = {
            accessToken: (_a = account.access_token) !== null && _a !== void 0 ? _a : '',
            expiresAt: (_b = account.expires_at) !== null && _b !== void 0 ? _b : 0,
            refreshToken: (_c = account.refresh_token) !== null && _c !== void 0 ? _c : '',
        };
    }
    else if (Date.now() >= token.expiresAt * 1000) {
        try {
            const freshToken = yield (0, okta_1.getFreshToken)(okta, jwt.refreshToken);
            jwt = {
                accessToken: freshToken.access_token,
                expiresAt: Math.floor(Date.now() / 1000 + freshToken.expires_in),
                refreshToken: freshToken.refresh_token,
            };
        }
        catch (e) {
            console.error(e);
            if (e instanceof exceptions_1.RefreshAccessTokenException) {
                token.error = e.message;
            }
            else if (e instanceof exceptions_1.RefreshTokenFailedException) {
                token.error = e.message;
            }
        }
    }
    return yield callback(jwt, token, account);
});
const generateCallbacks = (callbacks, okta) => ({
    signIn: signIn(callbacks.signIn),
    redirect: redirect(callbacks.redirect),
    session: session(callbacks.session),
    jwt: jwt(callbacks.jwt, okta),
});
exports.generateCallbacks = generateCallbacks;
//# sourceMappingURL=callbacks.js.map